import { useSearchParams } from "react-router-dom";
import { Context } from "./Provider";
import { useState, useContext, useEffect, useMemo, useCallback } from "react";

const JobResultsInfo = () => {
    const { data, loading, jobParams, pageIndex } = useContext(Context);
    const [searchParams] = useSearchParams();
    const [paginationParamLoaded, setPaginationParamLoaded] = useState(false);
    const [totalFiltersSelected, setTotalFiltersSelected] = useState(0);
    const resultsPerPage = 20;

    const dataIndex = useMemo(
        () => Math.ceil(pageIndex / (1000 / resultsPerPage)),
        [pageIndex]
    );
    const resultsOffsetFirst = useMemo(
        () => pageIndex - (dataIndex - 1) * 50,
        [pageIndex, dataIndex]
    );

    // Extract the pagination param from URL query string
    const paginationParam = searchParams.get("pg")
        ? parseInt(searchParams.get("pg"))
        : null;

    // useEffect to manage setting the paginationParamLoaded state
    useEffect(() => {
        if (
            paginationParam !== null &&
            !isNaN(paginationParam) &&
            !paginationParamLoaded
        ) {
            setPaginationParamLoaded(true);
        }
    }, [paginationParam, paginationParamLoaded]);

    // for setting total filtered count
    useEffect(() => {
        const catFiltersSelected = jobParams?.categories?.length || 0;
        const stateFiltersSelected = jobParams?.states?.length || 0;
        const cityFiltersSelected = jobParams?.cities?.length || 0;
        setTotalFiltersSelected(
            catFiltersSelected + stateFiltersSelected + cityFiltersSelected
        );
    }, [jobParams]); // Recalculate when jobParams changes

    // Memoized function to toggle the filter
    const updateShowFilter = useCallback((e) => {
        e.preventDefault();
        document.body.classList.toggle("job-filter-active"); // Toggle modal-open class on body
    }, []);

    // Function to build the job info, memoized to avoid re-creation unless results change
    const buildJobInfo = useCallback(
        (num_results, results_per_page) => {
            let num_of_pages = Math.ceil(
                num_results / results_per_page
            ).toLocaleString();
            let formatted_num_results = num_results.toLocaleString();
            const resultsText = num_results === 1 ? "Job" : "Jobs";

            return (
              <div className="row job-results-meta">
                <div className="job-list-details">
                  <span className="pagination-details">
                    {`Page ${pageIndex} of ${num_of_pages} | ${formatted_num_results} ${resultsText} Found`}
                  </span>
                </div>
                <div className="job-links-btn job-search-button-container">
                  {/* <button
                            onClick={updateShowFilter}
                            id="openJobFilters"
                            aria-label="Open filters"
                            type="button"
                            className="links-btn"
                        >
                          <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.4169 1L27.6013 1C27.9619 1 28.2568 1.29497 28.2568 1.65549C28.2568 2.01601 27.9619 2.31098 27.6013 2.31098L13.0724 2.31098L13.0724 25.689L27.6013 25.689C27.9619 25.689 28.2568 25.984 28.2568 26.3445C28.2568 26.705 27.9619 27 27.6013 27L12.4169 27C12.0564 27 11.7614 26.705 11.7614 26.3445L11.7614 1.65549C11.7614 1.29169 12.0531 1 12.4169 1Z" fill="#4DAFF1" stroke="#4DAFF1" stroke-width="0.75"></path>
                                        <path d="M6.89756 8.09896C7.06471 8.09896 7.23186 8.16123 7.35968 8.29233C7.61532 8.54797 7.61532 8.96421 7.35968 9.21985L2.57788 14.0016L7.36296 18.7802C7.6186 19.0358 7.6186 19.452 7.36296 19.7077C7.10732 19.9633 6.69108 19.9633 6.43544 19.7077L1.19152 14.4638C0.93588 14.2081 0.93588 13.7919 1.19152 13.5362L6.43544 8.29233C6.56326 8.16451 6.73041 8.09896 6.89756 8.09896Z" fill="#4DAFF1" stroke="#4DAFF1" stroke-width="0.75"></path>
                                        <path d="M17.8773 20.0088L25.0877 20.0088C25.4482 20.0088 25.7432 20.3038 25.7432 20.6643C25.7432 21.0249 25.4482 21.3198 25.0877 21.3198L17.8773 21.3198C17.5168 21.3198 17.2218 21.0249 17.2218 20.6643C17.2218 20.3038 17.5168 20.0088 17.8773 20.0088Z" fill="#4DAFF1" stroke="#4DAFF1" stroke-width="0.75"></path>
                                        <path d="M17.8773 13.3985L25.0877 13.3985C25.4482 13.3985 25.7432 13.6935 25.7432 14.054C25.7432 14.4145 25.4482 14.7095 25.0877 14.7095L17.8773 14.7095C17.5168 14.7095 17.2218 14.4145 17.2218 14.054C17.2218 13.6935 17.5168 13.3985 17.8773 13.3985Z" fill="#4DAFF1" stroke="#4DAFF1" stroke-width="0.75"></path>
                                        <path d="M17.8773 6.79107L25.0877 6.79107C25.4482 6.79107 25.7432 7.08604 25.7432 7.44656C25.7432 7.80708 25.4482 8.10205 25.0877 8.10205L17.8773 8.10205C17.5168 8.10205 17.2218 7.80708 17.2218 7.44656C17.2218 7.08604 17.5168 6.79107 17.8773 6.79107Z" fill="#4DAFF1" stroke="#4DAFF1" stroke-width="0.75"></path>
                                    </svg>
                            Job Type & Setting
                        </button> */}
                                <a
                                    href="#"
                                    onClick={updateShowFilter}
                                    id="openJobFilters"
                                    className="links-btn"
                                >                                    
                                    Job Type & Setting
                                    <svg
                                    width="29"
                                    height="28"
                                    viewBox="0 0 29 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    >
                                    <path
                                        d="M12.4169 1L27.6013 1C27.9619 1 28.2568 1.29497 28.2568 1.65549C28.2568 2.01601 27.9619 2.31098 27.6013 2.31098L13.0724 2.31098L13.0724 25.689L27.6013 25.689C27.9619 25.689 28.2568 25.984 28.2568 26.3445C28.2568 26.705 27.9619 27 27.6013 27L12.4169 27C12.0564 27 11.7614 26.705 11.7614 26.3445L11.7614 1.65549C11.7614 1.29169 12.0531 1 12.4169 1Z"
                                        fill="#4DAFF1"
                                        stroke="#4DAFF1"
                                        stroke-width="0.75"
                                    ></path>
                                    <path
                                        d="M6.89756 8.09896C7.06471 8.09896 7.23186 8.16123 7.35968 8.29233C7.61532 8.54797 7.61532 8.96421 7.35968 9.21985L2.57788 14.0016L7.36296 18.7802C7.6186 19.0358 7.6186 19.452 7.36296 19.7077C7.10732 19.9633 6.69108 19.9633 6.43544 19.7077L1.19152 14.4638C0.93588 14.2081 0.93588 13.7919 1.19152 13.5362L6.43544 8.29233C6.56326 8.16451 6.73041 8.09896 6.89756 8.09896Z"
                                        fill="#4DAFF1"
                                        stroke="#4DAFF1"
                                        stroke-width="0.75"
                                    ></path>
                                    <path
                                        d="M17.8773 20.0088L25.0877 20.0088C25.4482 20.0088 25.7432 20.3038 25.7432 20.6643C25.7432 21.0249 25.4482 21.3198 25.0877 21.3198L17.8773 21.3198C17.5168 21.3198 17.2218 21.0249 17.2218 20.6643C17.2218 20.3038 17.5168 20.0088 17.8773 20.0088Z"
                                        fill="#4DAFF1"
                                        stroke="#4DAFF1"
                                        stroke-width="0.75"
                                    ></path>
                                    <path
                                        d="M17.8773 13.3985L25.0877 13.3985C25.4482 13.3985 25.7432 13.6935 25.7432 14.054C25.7432 14.4145 25.4482 14.7095 25.0877 14.7095L17.8773 14.7095C17.5168 14.7095 17.2218 14.4145 17.2218 14.054C17.2218 13.6935 17.5168 13.3985 17.8773 13.3985Z"
                                        fill="#4DAFF1"
                                        stroke="#4DAFF1"
                                        stroke-width="0.75"
                                    ></path>
                                    <path
                                        d="M17.8773 6.79107L25.0877 6.79107C25.4482 6.79107 25.7432 7.08604 25.7432 7.44656C25.7432 7.80708 25.4482 8.10205 25.0877 8.10205L17.8773 8.10205C17.5168 8.10205 17.2218 7.80708 17.2218 7.44656C17.2218 7.08604 17.5168 6.79107 17.8773 6.79107Z"
                                        fill="#4DAFF1"
                                        stroke="#4DAFF1"
                                        stroke-width="0.75"
                                    ></path>
                                    </svg>
                  </a>
                </div>
              </div>
            );
        },
        [pageIndex, totalFiltersSelected, updateShowFilter]
    );

    if (!loading) {
        if (
            paginationParamLoaded ||
            (data?.hits?.total?.value > 0 &&
                paginationParam <=
                    Math.ceil(
                        data?.aggregations["job_count"]["value"] /
                            resultsPerPage
                    ))
        ) {
            return buildJobInfo(
                data.aggregations["job_count"]["value"],
                resultsPerPage
            );
        }
    }

    // In case loading or data is not available, render nothing or loading state
    return (
        <div
            className="row job-results-meta"
            style={{ opacity: loading ? "0.6" : "1" }}
        >

            <div className="job-list-details">
                <span className="pagination-details">
                    {`Page 1 of 1 | 0 Jobs Found`}
                </span>
            </div>
            <div className="job-search-button-container">
                <button
                    onClick={updateShowFilter}
                    id="openJobFilters"
                    aria-label="Open filters"
                    type="button"
                    className="micro-btn red-border-btn btn-job-filter"
                    disabled={loading} // Disables the button if loading is true
                >
                    <svg
                        width="19"
                        height="18"
                        viewBox="0 0 19 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clip-path="url(#clip0_11308_5177)">
                            <path
                                d="M18.2568 1.64475H6.93611C6.62399 0.691717 5.75202 0 4.72151 0C3.691 0 2.81903 0.691717 2.51186 1.64475H0.743155C0.331943 1.64475 0 1.98804 0 2.41332C0 2.8386 0.331943 3.1819 0.743155 3.1819H2.51186C2.82399 4.14005 3.69596 4.82664 4.72647 4.82664C5.75697 4.82664 6.62894 4.13493 6.94107 3.1819H18.2618C18.673 3.1819 19.005 2.8386 19.005 2.41332C19.005 1.98804 18.6681 1.64475 18.2568 1.64475ZM4.72151 3.29462C4.2558 3.29462 3.87431 2.90009 3.87431 2.41845C3.87431 1.93681 4.2558 1.53715 4.72151 1.53715C5.18722 1.53715 5.56871 1.93168 5.56871 2.41332C5.56871 2.89496 5.19218 3.29462 4.72151 3.29462Z"
                                fill="#C81330"
                            />
                            <path
                                d="M18.2568 8.2341H16.4881C16.176 7.27595 15.304 6.58936 14.2735 6.58936C13.243 6.58936 12.3711 7.28107 12.0589 8.2341H0.743155C0.331943 8.2341 0 8.5774 0 9.00267C0 9.42795 0.331943 9.77125 0.743155 9.77125H12.0639C12.376 10.7294 13.248 11.416 14.2785 11.416C15.309 11.416 16.181 10.7243 16.4931 9.77125H18.2618C18.673 9.77125 19.005 9.42795 19.005 9.00267C19.005 8.5774 18.6681 8.2341 18.2568 8.2341ZM14.2735 9.87885C13.8078 9.87885 13.4263 9.48431 13.4263 9.00267C13.4263 8.52104 13.8078 8.1265 14.2735 8.1265C14.7392 8.1265 15.1207 8.52104 15.1207 9.00267C15.1207 9.48431 14.7442 9.87885 14.2735 9.87885Z"
                                fill="#C81330"
                            />
                            <path
                                d="M18.2568 14.818H10.1218C9.80965 13.8598 8.93768 13.1732 7.90717 13.1732C6.87666 13.1732 6.00469 13.8649 5.69257 14.818H0.743155C0.331943 14.818 0 15.1613 0 15.5865C0 16.0118 0.331943 16.3551 0.743155 16.3551H5.69257C6.00469 17.3133 6.87666 17.9999 7.90717 17.9999C8.93768 17.9999 9.80965 17.3081 10.1218 16.3551H18.2568C18.6681 16.3551 19 16.0118 19 15.5865C19 15.1613 18.6681 14.818 18.2568 14.818ZM7.90717 16.4627C7.44146 16.4627 7.05997 16.0682 7.05997 15.5865C7.05997 15.1049 7.44146 14.7104 7.90717 14.7104C8.37288 14.7104 8.75437 15.1049 8.75437 15.5865C8.75437 16.0682 8.37288 16.4627 7.90717 16.4627Z"
                                fill="#C81330"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_11308_5177">
                                <rect width="19" height="18" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    Filter
                </button>
            </div>
        </div>
    ); // Fallback to null if loading or data isn't ready
};

export default JobResultsInfo;
